import { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'

import { NavigatorBannerComponent } from './components/NavigatorBanner'
import { NavigationBarComponent } from './components/NavigationBarComponent'
import { ScrollToTop } from './components/ScrollToTop'
import { SpinnerComponent } from './components/Spinner'

import { DealDetailPage } from './pages/DealDetail'
import { LoginPage } from './pages/Login'
import { MainPage } from './pages/Main'
import { SearchResultsPage } from './pages/SearchResults'

import { useSimpleState } from './hooks/useSimpleState'
import { useView } from './hooks/useView'

import { AppProvider } from './hooks/useAppContext/context'

import { theme } from './theme'

import './styles/main.css'


function App() {
    const { _state } = useSimpleState({})

    const {_view} = useView({
        initialView: 'main',
        views: {
            loading: renderLoading,
            main: renderMain
        }
    })

    function renderLoading() {
        return (
            <div className="app-container">
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        return (
            <div className="app-container">
                <ThemeProvider theme={theme}>
                    <AppProvider value={{ _state }}>
                        <BrowserRouter>
                            <ScrollToTop>
                                <NavigationBarComponent />
                                {/* <NavigatorBannerComponent /> */}
                                <Routes>
                                    <Route path="/login" element={<LoginPage />} exact />
                                    <Route path="/" element={<MainPage />} />
                                    <Route path="/search" element={<SearchResultsPage />} />
                                    <Route path="/deals/:id" element={<DealDetailPage />} />
                                    <Route path="/deals/:id/:slug" element={<DealDetailPage />} />
                                </Routes>
                            </ScrollToTop>
                        </BrowserRouter>
                    </AppProvider>
                </ThemeProvider>
            </div>
        )
    }

    return _view.get()
}

export default App;
